module.exports = __webpack_public_path__ + "static/img/1-6.3d6f1f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-6.jpg
// module id = 1a+Z
// module chunks = 1